import { render } from "./ButtonGoView.vue?vue&type=template&id=0b16179e&scoped=true"
import script from "./ButtonGoView.vue?vue&type=script&lang=js"
export * from "./ButtonGoView.vue?vue&type=script&lang=js"

import "./ButtonGoView.vue?vue&type=style&index=0&id=0b16179e&scoped=true&lang=css"

import exportComponent from "/home/glassplant/agi.co.jp/roots-prod/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b16179e"]])

export default __exports__